import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import LeftLeafSVG from '../../WelcomeMeet/LeftLeafSVG';
import RightLeafSVG from '../../WelcomeMeet/RightLeafSVG';


const styles = {
  demoPage: {
    position: 'relative',
    background: `
      linear-gradient(to bottom, rgba(255,255,255,0) 80%, #FFFFFF 100%),
      radial-gradient(circle at 10% 20%, rgba(251, 219, 164, 0.4) 0%, transparent 40%),
      radial-gradient(circle at 90% 60%, rgba(240, 192, 96, 0.3) 0%, transparent 40%),
      radial-gradient(circle at 50% 90%, rgba(240, 160, 96, 0.2) 0%, transparent 50%),
      #FEFDF8
    `,
    color: '#4A4036',
    fontFamily: "'Inter', sans-serif",
    overflowX: 'hidden',
    padding: '110px 20px 90px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  demoMain: {
    width: '100%',
    maxWidth: '1240px',
    zIndex: 5,
    position: 'relative',
    margin: '0 auto',
    display: 'block'
  },
  headingBlock: {
    textAlign: 'center',
    maxWidth: '860px',
    margin: '0 auto 20px',
    position: 'relative',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  mainHeading: {
    fontSize: '3.4rem',
    fontWeight: 800,
    lineHeight: 1.12,
    color: '#383028',
    marginBottom: '18px',
    letterSpacing: '-0.01em'
  },
  highlightText: {
    color: '#B87A10'
  },
  subHeading: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: '#5A5044',
    marginBottom: '28px',
    fontFamily: "'Inter', sans-serif"
  },
  coSponsorSection: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '40px'
  },
  coSponsorText: {
    fontSize: '0.9rem',
    fontWeight: 600,
    color: '#8a7c68',
    letterSpacing: '1px',
    textTransform: 'uppercase'
  },
  smSponsorPill: {
    margin: 0,
    padding: '16px 32px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '16px',
    borderRadius: '14px',
    background: '#fff',
    border: '1px solid #EAEAEA',
    boxShadow: '0 10px 30px rgba(0,0,0,0.07)'
  },
  smSponsorLogo: {
    height: '28px',
    width: 'auto'
  },
  photoStrip: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',
    marginTop: '30px',
    marginBottom: '10px',
    zIndex: 15
  },
  polaroidWrapper: {
    position: 'relative',
    display: 'inline-block'
  },
  p1Wrapper: {
    marginTop: '60px',
    zIndex: 8
  },
  p2Wrapper: {
    marginLeft: '-40px',
    marginTop: '-30px',
    zIndex: 16
  },
  p3Wrapper: {
    marginLeft: '-40px',
    marginTop: '50px',
    zIndex: 10
  },
  polaroid: {
    background: 'white',
    padding: '14px 14px 52px 14px',
    boxShadow: '0 24px 50px rgba(0,0,0,0.16)',
    borderRadius: '6px',
    border: '1px solid #F0F0F0',
    transition: 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    position: 'relative',
    zIndex: 5
  },
  p1: {
    transform: 'rotate(-7deg)'
  },
  p2: {
    transform: 'rotate(2deg)'
  },
  p3: {
    transform: 'rotate(8deg)'
  },
  polaroidImg: {
    width: '340px',
    height: '340px',
    objectFit: 'cover',
    borderRadius: '3px',
    display: 'block'
  },
  polaroidImgLarge: {
    width: '400px',
    height: '400px',
    objectFit: 'cover',
    borderRadius: '3px',
    display: 'block'
  },
  floatingImg: {
    position: 'absolute',
    zIndex: 25,
    filter: 'drop-shadow(0 15px 25px rgba(0,0,0,0.15))',
    pointerEvents: 'none'
  },
  orangeCircle: {
    position: 'absolute',
    width: '520px',
    height: '480px',
    borderRadius: '50%',
    background: '#F0A551',
    opacity: 0.25,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
    pointerEvents: 'none'
  },
  lemon: {
    width: '95px',
    top: '-15px',
    left: '-65px',
    display: 'none',
    rotate: '-60deg',
    animation: 'floatLemon 6s ease-in-out infinite'
  },
  drink: {
    width: '95px',
    bottom: '-60px',
    right: '-45px',
    animation: 'floatDrink 8s ease-in-out infinite alternate'
  },
  demoMainBottom: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: '24px',
    flexWrap: 'wrap',
    marginTop: '70px',
    marginBottom: '50px',
    zIndex: 15
  },
  primaryBtn: {
    background: '#FBA834',
    color: 'white',
    border: 'none',
    padding: '16px 40px',
    borderRadius: '40px',
    fontWeight: 700,
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 8px 20px rgba(210, 123, 50, 0.3)',
    transition: 'all 0.3s ease',
    letterSpacing: '0.5px',
    textDecoration: 'none'
  },
  secondaryBtn: {
    background: 'transparent',
    color: '#FBA834',
    border: '2px solid #FBA834',
    padding: '16px 40px',
    borderRadius: '40px',
    fontWeight: 700,
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    letterSpacing: '0.5px',
    textDecoration: 'none'
  },
  demoFooter: {
    textAlign: 'center',
    color: '#555',
    fontSize: '1rem',
    lineHeight: 1.8,
    maxWidth: '650px',
    zIndex: 5,
    fontWeight: 500,
    margin: '0 auto'
  },
  demoFooterP: {
    margin: '6px 0'
  }
};

export default function DemoPage() {
  const [previewImage, setPreviewImage] = useState(null);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Playfair+Display:ital,wght@0,600;0,700;0,800;1,600&display=swap');

        @keyframes floatLemon {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
          100% { transform: translateY(0px); }
        }

        @keyframes floatDrink {
          0% { transform: translateY(0px); }
          100% { transform: translateY(-20px); }
        }

        .polaroid:hover {
          transform: scale(1.05) translateY(-10px) !important;
          z-index: 30 !important;
          box-shadow: 0 30px 60px rgba(0,0,0,0.25);
        }

        .polaroid-overlay {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;
          border-radius: 3px;
          cursor: zoom-in;
        }
        .polaroid-inner:hover .polaroid-overlay {
          opacity: 1;
        }
        .view-icon {
          color: white;
          font-size: 16px;
          font-weight: 700;
          letter-spacing: 1px;
          background: rgba(255,255,255,0.2);
          padding: 8px 16px;
          border-radius: 20px;
          border: 1px solid white;
          backdrop-filter: blur(4px);
        }

        .primary-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 15px 35px rgba(210, 123, 50, 0.5);
        }
        .secondary-btn:hover {
          transform: translateY(-3px);
          background: rgba(210, 123, 50, 0.05);
        }

        @media (max-width: 1200px) {
          .polaroid-img { width: 300px !important; height: 300px !important; }
          .polaroid-img-large { width: 350px !important; height: 350px !important; }
        }

        @media (max-width: 992px) {
          .photo-strip {
            flex-direction: row !important;
            flex-wrap: nowrap !important;
            justify-content: center !important;
            align-items: center !important;
            gap: 0 !important;
            margin-top: 20px !important;
          }
          .main-heading { font-size: 2.2rem !important; }
          .sub-heading {
            font-size: 1.1rem !important;
            line-height: 1.9 !important;
            padding: 0 6px !important;
          }
          .p-1-wrapper, .p-2-wrapper, .p-3-wrapper {
            width: auto !important;
            display: inline-block !important;
          }
          .p-1-wrapper { margin: 34px 0 0 0 !important; z-index: 8 !important; }
          .p-2-wrapper { margin: -18px 0 0 -55px !important; z-index: 16 !important; }
          .p-3-wrapper { margin: 30px 0 0 -55px !important; z-index: 10 !important; }
          .p-1 { transform: rotate(-7deg) !important; }
          .p-2 { transform: rotate(2deg) !important; }
          .p-3 { transform: rotate(8deg) !important; }
          .demo-lemon, .drink { display: none !important; }
          .orange-circle {
            display: block !important;
            width: 340px !important;
            height: 340px !important;
            opacity: 0.2 !important;
          }
          .polaroid {
            padding: 10px 10px 30px 10px !important;
            width: auto !important;
            max-width: none !important;
          }
          img.polaroid-img {
            width: 185px !important;
            height: 185px !important;
            aspect-ratio: 1 / 1 !important;
          }
          img.polaroid-img-large {
            width: 235px !important;
            height: 235px !important;
            aspect-ratio: 1 / 1 !important;
          }
          .demo-page-container {
            padding-top: 60px !important;
            padding-bottom: 40px !important;
          }
          .buttons-wrapper {
            margin-top: 40px !important;
            margin-bottom: 24px !important;
          }
        }

        @media (max-width: 600px) {
          .buttons-wrapper {
            flex-direction: column !important;
            align-items: center !important;
            gap: 14px !important;
          }
          .primary-btn, .secondary-btn {
            width: 100% !important;
            max-width: 320px !important;
            text-align: center !important;
            padding: 15px 24px !important;
          }
          .p-1-wrapper { margin: 24px 0 0 0 !important; }
          .p-2-wrapper { margin: -12px 0 0 -66px !important; }
          .p-3-wrapper { margin: 22px 0 0 -66px !important; }
          .co-sponsor-section span { font-size: 0.72rem !important; letter-spacing: 0.5px !important; }
          .co-sponsor-section > div { padding: 10px 22px !important; border-radius: 10px !important; }
          .co-sponsor-section img { height: 20px !important; }
          .polaroid { padding: 8px 8px 24px 8px !important; }
          img.polaroid-img { width: 150px !important; height: 150px !important; }
          img.polaroid-img-large { width: 195px !important; height: 195px !important; }
          .orange-circle { width: 280px !important; height: 280px !important; }
        }

        @media (max-width: 480px) {
          .demo-page-container {
            padding-left: 14px !important;
            padding-right: 14px !important;
          }
          .main-heading {
            font-size: 1.75rem !important;
            line-height: 1.2 !important;
          }
          .sub-heading { font-size: 1rem !important; }
          .co-sponsor-section { margin-bottom: 24px !important; }
          .p-1-wrapper { margin: 20px 0 0 0 !important; }
          .p-2-wrapper { margin: -10px 0 0 -78px !important; }
          .p-3-wrapper { margin: 18px 0 0 -78px !important; }
          .polaroid { padding: 6px 6px 20px 6px !important; }
          img.polaroid-img { width: 140px !important; height: 140px !important; }
          img.polaroid-img-large { width: 185px !important; height: 185px !important; }
          .orange-circle { width: 240px !important; height: 240px !important; }
        }

        @media (max-width: 360px) {
          .p-2-wrapper { margin-left: -66px !important; }
          .p-3-wrapper { margin-left: -66px !important; }
          .polaroid { padding: 5px 5px 16px 5px !important; }
          img.polaroid-img { width: 115px !important; height: 115px !important; }
          img.polaroid-img-large { width: 160px !important; height: 160px !important; }
          .orange-circle { width: 210px !important; height: 210px !important; }
        }
      `}</style>
      <div style={{ width: "100%", overflowX: "hidden" }}>
        <div style={styles.demoPage} className="demo-page-container">
          <LeftLeafSVG />
          <RightLeafSVG />

          <main style={styles.demoMain}>
            <div style={styles.headingBlock}>
              <h1 style={styles.mainHeading} className="main-heading">
                <span style={styles.highlightText}>MSB Association Summer Members Meet 2026</span> <br/> — What a evening!
              </h1>
              <h2 style={styles.subHeading} className="sub-heading">
                • Relive the moments • Stay connected • See you at the next one
              </h2>

              <div style={styles.coSponsorSection} className="co-sponsor-section">
                <span style={styles.coSponsorText}>Sponsored by</span>
                <div style={styles.smSponsorPill}>
                  <img src="/assets/images/peratera-logo-black.svg" alt="Peratera" style={styles.smSponsorLogo} />
                </div>
              </div>
            </div>

            <div style={styles.photoStrip} className="photo-strip">
              <div style={styles.orangeCircle} className="orange-circle"></div>

              <div style={{ ...styles.polaroidWrapper, ...styles.p1Wrapper }} className="polaroid-wrapper p-1-wrapper">
                <div style={{ ...styles.polaroid, ...styles.p1 }} className="polaroid p-1">
                  <div style={{ position: 'relative', display: 'inline-block' }} className="polaroid-inner" onClick={() => setPreviewImage("/assets/images/gallery/year-2026/summer-meet-2026/Board-memebers/4.webp")}>
                    <img src="/assets/images/gallery/year-2026/summer-meet-2026/Board-memebers/4.webp" alt="Networking Event" style={styles.polaroidImg} className="polaroid-img" />
                    <div className="polaroid-overlay"><span className="view-icon">VIEW</span></div>
                  </div>
                </div>
                <img src="/assets/images/lemon_slice.png" alt="Lemon Slice" style={{ ...styles.floatingImg, ...styles.lemon }} className="floating-img demo-lemon" />
              </div>

              <div style={{ ...styles.polaroidWrapper, ...styles.p2Wrapper }} className="polaroid-wrapper p-2-wrapper">
                <div style={{ ...styles.polaroid, ...styles.p2 }} className="polaroid p-2">
                  <div style={{ position: 'relative', display: 'inline-block' }} className="polaroid-inner" onClick={() => setPreviewImage("/assets/images/gallery/year-2026/summer-meet-2026/1.webp")}>
                    <img src="/assets/images/gallery/year-2026/summer-meet-2026/1.webp" alt="Corporate Meeting" style={styles.polaroidImgLarge} className="polaroid-img-large" />
                    <div className="polaroid-overlay"><span className="view-icon">VIEW</span></div>
                  </div>
                </div>
              </div>

              <div style={{ ...styles.polaroidWrapper, ...styles.p3Wrapper }} className="polaroid-wrapper p-3-wrapper">
                <div style={{ ...styles.polaroid, ...styles.p3 }} className="polaroid p-3">
                  <div style={{ position: 'relative', display: 'inline-block' }} className="polaroid-inner" onClick={() => setPreviewImage("/assets/images/gallery/year-2026/summer-meet-2026/4.webp")}>
                    <img src="/assets/images/gallery/year-2026/summer-meet-2026/4.webp" alt="Business Strategy" style={styles.polaroidImg} className="polaroid-img" />
                    <div className="polaroid-overlay"><span className="view-icon">VIEW</span></div>
                  </div>
                </div>
                <img src="/assets/images/spritz_drink.png" alt="Spritz Drink" style={{ ...styles.floatingImg, ...styles.drink }} className="floating-img drink" />
              </div>
            </div>

            <div style={styles.demoMainBottom} className="buttons-wrapper">
              <a style={styles.primaryBtn} className="primary-btn" href="/summer-members-meet-2026">VIEW EVENT SUMMARY</a>
              <a style={styles.secondaryBtn} className="secondary-btn" href="/photos-gallery-2026">VIEW GALLERY</a>
            </div>

            {previewImage && createPortal(
              <div style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                zIndex: 99999,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '24px',
                cursor: 'zoom-out'
              }} onClick={() => setPreviewImage(null)}>
                <div style={{
                  position: 'absolute',
                  top: '30px',
                  right: '40px',
                  color: 'white',
                  fontSize: '40px',
                  cursor: 'pointer',
                  fontWeight: '300'
                }}>✕</div>
                <img src={previewImage} alt="Preview" style={{
                  maxWidth: '90%',
                  maxHeight: '80%',
                  objectFit: 'contain',
                  borderRadius: '4px',
                  boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
                  cursor: 'default'
                }} onClick={(e) => e.stopPropagation()} />
                <a
                  href="/photos-gallery-2026"
                  style={{
                    background: '#FBA834',
                    color: 'white',
                    border: 'none',
                    padding: '14px 32px',
                    borderRadius: '40px',
                    fontWeight: 700,
                    fontSize: '1rem',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    zIndex: 10000,
                    boxShadow: '0 8px 20px rgba(210, 123, 50, 0.3)',
                    letterSpacing: '0.5px'
                  }}
                  onClick={(e) => e.stopPropagation()}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 12px 28px rgba(210, 123, 50, 0.5)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 8px 20px rgba(210, 123, 50, 0.3)';
                  }}
                >
                  VIEW ALL IMAGES
                </a>
              </div>,
              document.body
            )}
          </main>

          <footer style={styles.demoFooter}>
            <p style={styles.demoFooterP}>Friday's rooftop gathering brought together some of the brightest minds in the MSB and fintech ecosystem.</p>
            <p style={styles.demoFooterP}>Check out the gallery to relive the best moments and collaborations.</p>
          </footer>
        </div>
      </div>
    </>
  );
}
